// extracted by mini-css-extract-plugin
export default {"content":"bgRtt","title":"zT3wi","description":"MVRmr","buttons-wrapper":"tkzDP"};